import { useState, useEffect } from "react";

import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Box
} from "@mui/material";
import SoftBox from "../../../components/SoftBox";
import SoftTypography from "../../../components/SoftTypography";
import SoftInput from "../../../components/SoftInput";
import SoftButton from "../../../components/SoftButton";
import PropTypes from "prop-types";

const  EditCategoryModal = ({ isOpen, onClose, category, onSave }) => {
    const [formData, setFormData] = useState({ en: "", ar: "" });

    useEffect(() => {
        if (category) {
            setFormData(category.name);
        } else {
            setFormData({ en: "", ar: "" });
        }
    }, [category, isOpen]);

    const handleSave = () => {
        if (formData.en.trim() && formData.ar.trim()) {
            let updatedCategory;

            if (category) {
                updatedCategory = {
                    id: category.id,
                    name: formData,
                    questionCount: category?.questionCount || 0,
                };
            } else {
                updatedCategory = {
                    name: formData,
                    questionCount: 0,
                };
            }

            onSave(updatedCategory);
            onClose();
        }
    };

    return (
        <Dialog open={isOpen} onClose={onClose}
                fullWidth
                maxWidth="md"
                sx={{ "& .MuiPaper-root": { width: "40%" } }}
        >
            <DialogTitle>
                <Box display="flex" alignItems="center" gap={2}>
                    <SoftTypography variant="h6" fontWeight="bold">
                        {category ? "Edit Category" : "Add New Category"}
                    </SoftTypography>
                </Box>
            </DialogTitle>

            <DialogContent dividers>
                <SoftBox
                    borderRadius="xl"
                    display="flex"
                    flexDirection="column"
                    gap={3}
                    boxShadow="soft"
                    bgcolor="white"
                >
                    <SoftBox display="flex" flexDirection="column" gap={2} py={2}>
                        {/* English Name */}
                        <SoftBox display="flex" flexDirection="column" gap={1}>
                            <SoftTypography variant="body2" fontWeight="medium">
                                Category Name (English)
                            </SoftTypography>
                            <SoftInput
                                value={formData.en}
                                onChange={(e) =>
                                    setFormData((prev) => ({ ...prev, en: e.target.value }))
                                }
                                placeholder="Enter category name in English"
                            />
                        </SoftBox>

                        {/* Arabic Name */}
                        <SoftBox display="flex" flexDirection="column" gap={1}>
                            <SoftTypography variant="body2" fontWeight="medium">
                                Category Name (Arabic)
                            </SoftTypography>
                            <SoftInput
                                value={formData.ar}
                                onChange={(e) =>
                                    setFormData((prev) => ({ ...prev, ar: e.target.value }))
                                }
                                placeholder="أدخل اسم الفئة بالعربية"
                                dir="rtl"
                            />
                        </SoftBox>
                    </SoftBox>
                </SoftBox>
            </DialogContent>

            <DialogActions>
                <SoftButton variant="outlined" color="secondary" onClick={onClose}>
                    Cancel
                </SoftButton>
                <SoftButton
                    variant="contained"
                    onClick={handleSave}
                    disabled={!formData.en.trim() || !formData.ar.trim()}
                >
                    {category ? "Update" : "Create"}
                </SoftButton>
            </DialogActions>
        </Dialog>
    );
};

EditCategoryModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    category: PropTypes.object,
    onSave: PropTypes.func,
};

export default EditCategoryModal;
